var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container pb-3 col-xs-12 col-sm-10 col-md-10 col-lg-6"},[_vm._t("default")],2),_c('div',{staticClass:"mb-3 d-none d-md-block"})])}
var staticRenderFns = []

export { render, staticRenderFns }